import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Modal,
  Select,
  format_date,
  ActionIconButton,
  ACTION_ICONS,
  t // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js"; 
import { can } from "../../utils/permission.js";
import InfoTooltip from "./checklist-templates/InfoTooltip.js";
import ChecklistTreeEditor from "./checklist-templates/ChecklistTreeEditor.js";
import StatusPicker, { StatusPill, statusLabel } from "./checklist-templates/StatusPicker.js";
import { formatNumber } from "../../utils/formatting";
import {
  buildTree,
  cloneTree,
  countItems,
  findProblem,
  summarize,
  toPayload,
} from "./checklist-templates/checklistTree.js";

// ฟีเจอร์ที่ซ่อนไว้ชั่วคราว (ยังไม่ใช้งาน) - เปลี่ยนเป็น true เมื่อกลับมาใช้ โค้ดและข้อมูลเดิมยังอยู่ครบ
// SHOW_FAIL_NOTIFY: กล่อง "แจ้งเตือนทางอีเมลเมื่อผลไม่ผ่าน" (ต้องเปิด CHECKLIST_FAIL_NOTIFY_ENABLED ฝั่ง backend คู่กัน)
// SHOW_REMARK_OPTION: ตัวเลือก Remark ข้างหัวข้อรายการตรวจสอบ (ซ่อนแล้วค่า is_remark_enabled คงตามเดิม)
const SHOW_FAIL_NOTIFY = false;
const SHOW_REMARK_OPTION = false;

// ประเภทคำตอบของรายการตรวจ - ใช้แสดง badge ตอนดู (ตอนสร้าง/แก้ใช้ dropdown ใน ChecklistTreeEditor)
// check/yesno = Toggle (3 ตัวเลือก), checkbox = Toggle (2 ตัวเลือก), qty = จำนวน (ตัวเลขพร้อมหน่วย)
const getInputTypeLabel = (value) =>
  ({
    check: t("ct_type_toggle3"),
    yesno: t("ct_type_toggle3"),
    checkbox: t("ct_type_toggle2"),
    measurement: t("ct_type_measurement"),
    text: t("ct_type_text"),
    qty: t("ct_type_qty"),
  }[value] || value || "-");

// สถานะของเทมเพลตจาก response (เผื่อ response เก่าที่มีแต่ is_active)
const getTemplateStatus = (item) => item?.status || (item?.is_active === false ? "inactive" : "active");

// แสดงรายการในต้นไม้ (โหมดดู) พร้อมเลขลำดับ 1, 2, 2.1
const renderViewNodes = (list, prefix = "") => {
  let sec = 0;
  let idx = 0;
  return list.map((node) => {
    if (node.kind === "section") {
      sec += 1;
      const num = `${prefix}${sec}`;
      return (
        <div key={node.id}>
          <div className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2 mb-2" style={{ background: "#e8efff", borderLeft: "4px solid #2563eb" }}>
            <div className="fw-bold text-dark text-14"><span className="text-primary me-2">{num}</span>{node.name}</div>
            <span className="text-secondary text-12">{countItems(node.children)} {t("items")}</span>
          </div>
          <div className="d-flex flex-column gap-2 mb-2" style={{ marginLeft: "14px", paddingLeft: "16px", borderLeft: "2px dashed #c5cedb" }}>
            {renderViewNodes(node.children, `${num}.`)}
          </div>
        </div>
      );
    }
    idx += 1;
    return (
      <div key={node.id} className="d-flex align-items-center justify-content-between bg-light rounded-3 p-3">
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded-circle bg-primary-light text-primary d-flex align-items-center justify-content-center fw-bold text-12 me-3 flex-shrink-0">
            {idx}
          </div>
          <div className="text-dark text-14">{node.description}</div>
        </div>
        <div className="ms-3 flex-shrink-0 d-flex align-items-center gap-2">
          {node.is_required && (
            <span className="badge bg-danger-light text-danger fw-bold px-2 py-1 text-11" style={{ backgroundColor: "#fdecec", color: "#e5484d" }}>
              {t("required_label")}
            </span>
          )}
          <span className="badge bg-primary-light text-primary fw-bold px-3 py-1 text-12">{getInputTypeLabel(node.input_type)}</span>
        </div>
      </div>
    );
  });
};

// ข้อความที่นำไปประกอบ html ของกล่องแจ้งผล (SweetAlert) ต้อง escape ก่อนเสมอ
const escapeHtml = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));

// dropdown ของช่องค้นหาผู้รับ แสดงไม่เกินจำนวนนี้ (ผู้ใช้ทั้งบริษัทมีหลักร้อย พิมพ์ค้นหาเพื่อกรองต่อได้)
const NOTIFY_USER_LIST_LIMIT = 50;

// กล่อง "แจ้งเตือนทางอีเมลเมื่อผลไม่ผ่าน" - เลือกผู้รับจากผู้ใช้ในระบบ (ระบบส่งไปที่อีเมลในข้อมูลผู้ใช้)
// ไม่มีสวิตช์เปิด/ปิด: มีผู้รับอย่างน้อย 1 คน = ส่ง, ไม่มี = ไม่ส่ง
// props: users = ผู้ใช้ทั้งหมดของบริษัท, value = ผู้รับที่เลือกไว้ (object ผู้ใช้), onChange(nextValue),
//        onTest = กดปุ่ม "ทดสอบส่งเมล" (ส่งอีเมลตัวอย่างถึงผู้รับที่เลือกไว้)
class NotifyRecipientPicker extends Component {
  // active_uid = ข้อที่ไฮไลต์อยู่ (null = ข้อแรกที่เลือกได้) - เก็บเป็น uid ไม่ใช่ index เพราะรายการเปลี่ยนทุกครั้งที่พิมพ์/เลือก
  state = { search: "", open: false, active_uid: null };
  inputRef = React.createRef();
  listRef = React.createRef();

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.open && prevState.active_uid !== this.state.active_uid) {
      this.listRef.current?.querySelector('[aria-selected="true"]')?.scrollIntoView({ block: "nearest" });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.blurTimer);
  }

  // ผู้ใช้ที่ยังไม่ถูกเลือกและตรงคำค้น (ชื่อ / ตำแหน่ง / อีเมล) - คนที่ยังไม่มีอีเมลไปอยู่ท้ายรายการและเลือกไม่ได้
  getHits = () => {
    const q = this.state.search.trim().toLowerCase();
    const selected = new Set(this.props.value.map((user) => user.uid));
    const hits = (this.props.users || []).filter(
      (user) =>
        !selected.has(user.uid) &&
        (!q || [user.full_name, user.position, user.email].some((field) => String(field || "").toLowerCase().includes(q)))
    );
    return [...hits.filter((user) => user.email), ...hits.filter((user) => !user.email)].slice(0, NOTIFY_USER_LIST_LIMIT);
  };

  // index ของข้อที่ไฮไลต์ในรายการปัจจุบัน - ไม่เจอ (ยังไม่ได้เลื่อน/ข้อนั้นหลุดจากรายการแล้ว) = ข้อแรกที่เลือกได้
  getActiveIndex = (hits) => {
    const index = hits.findIndex((user) => user.uid === this.state.active_uid && user.email);
    return index >= 0 ? index : hits.findIndex((user) => user.email);
  };

  // ไม่ส่ง search มา = เปิดรายการด้วยคำค้นเดิม
  openList = (search) => {
    this.setState((state) => ({ search: search ?? state.search, open: true, active_uid: null }));
  };

  closeList = () => this.setState({ open: false, active_uid: null });

  move = (step) => {
    const hits = this.getHits();
    if (!hits.some((user) => user.email)) return;
    let index = this.getActiveIndex(hits);
    do {
      index = (index + step + hits.length) % hits.length;
    } while (!hits[index].email);
    this.setState({ active_uid: hits[index].uid });
  };

  pick = (user) => {
    if (!user?.email) return;
    this.props.onChange([...this.props.value, user]);
    this.openList("");
    this.inputRef.current?.focus();
  };

  // เอาผู้รับออก - ถามยืนยันก่อนทุกครั้ง (ทั้งปุ่ม ✕ บนชิป และ Backspace ตอนช่องค้นหาว่าง) กันกดพลาด
  remove = async (user) => {
    const label = `${user.full_name || user.user_code || "-"}${user.email ? ` (${user.email})` : ""}`;
    const confirmed = await alert("", "warning", t("checklist_notify_remove_title"), `${t("checklist_notify_remove_confirm")} ${label}`, t("confirm"), t("cancel"));
    if (!confirmed) return;
    // อ่าน props ล่าสุดตอนยืนยันแล้ว เผื่อรายการเปลี่ยนระหว่างที่กล่องยืนยันเปิดอยู่
    this.props.onChange(this.props.value.filter((item) => item.uid !== user.uid));
    this.inputRef.current?.focus();
  };

  handleKeyDown = (e) => {
    const { open, search } = this.state;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (open) this.move(1);
      else this.openList();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      this.move(-1);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (open) {
        const hits = this.getHits();
        this.pick(hits[this.getActiveIndex(hits)]);
      }
    } else if (e.key === "Escape") {
      // preventDefault กันไม่ให้ modal ปิดตามไปด้วยตอนกด Esc เพื่อปิดแค่รายการ
      if (open) e.preventDefault();
      this.closeList();
    } else if (e.key === "Backspace" && !e.repeat && !search && this.props.value.length) {
      // !e.repeat: กด Backspace ค้างเพื่อลบคำค้นจนหมด ต้องไม่เด้งกล่องยืนยันลบผู้รับต่อทันที
      this.remove(this.props.value[this.props.value.length - 1]);
    }
  };

  // ทำตัวหนาสีฟ้าตรงส่วนที่ตรงกับคำค้น
  highlight = (text) => {
    const value = String(text || "");
    const q = this.state.search.trim().toLowerCase();
    const index = q ? value.toLowerCase().indexOf(q) : -1;
    if (index < 0) return value;
    return (
      <>
        {value.slice(0, index)}
        <span style={{ color: "#2563eb", fontWeight: 700 }}>{value.slice(index, index + q.length)}</span>
        {value.slice(index + q.length)}
      </>
    );
  };

  render() {
    const { value } = this.props;
    const { search, open } = this.state;
    const hits = open ? this.getHits() : [];
    const active = this.getActiveIndex(hits);
    const isOn = value.length > 0;

    return (
      <div className="rounded-3 p-3 mb-4" style={{ border: "1px solid #dbe1ea", backgroundColor: "#f7f9fc" }}>
        <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
          <div>
            <h5 className="fw-bold text-dark mb-1" style={{ fontSize: "16px" }}>{t("checklist_notify_title")}</h5>
            <div className="text-secondary text-12">{t("checklist_notify_desc")}</div>
          </div>
          {/* ป้ายสถานะ: มีผู้รับ = ส่ง (ฟ้า) / ไม่มี = ไม่ส่ง (เทา) */}
          <span
            className="flex-shrink-0 rounded-pill fw-bold text-12"
            aria-live="polite"
            style={{
              padding: "3px 10px",
              border: `1px solid ${isOn ? "transparent" : "#dbe1ea"}`,
              backgroundColor: isOn ? "#e8efff" : "#fff",
              color: isOn ? "#2563eb" : "#6b7688",
            }}
          >
            {isOn ? `${t("checklist_notify_status_on_prefix")} ${value.length} ${t("checklist_notify_status_on_suffix")}` : t("checklist_notify_status_off")}
          </span>
        </div>

        <div className="fw-bold text-dark text-13 mb-1" id="notify-recipient-label">{t("checklist_notify_to")}</div>
        <div className="d-flex align-items-start gap-2 flex-wrap flex-md-nowrap">
        <div
          className="d-flex flex-wrap align-items-center gap-2 bg-white rounded-3 position-relative flex-grow-1"
          style={{ minHeight: "40px", minWidth: 0, padding: "5px 6px", border: `1px solid ${open ? "#2563eb" : "#c5cedb"}`, cursor: "text" }}
          onClick={(e) => e.target === e.currentTarget && this.inputRef.current?.focus()}
        >
          {value.map((user) => (
            <span
              key={user.uid}
              className="d-inline-flex align-items-center rounded-pill fw-bold text-13"
              style={{
                gap: "6px",
                padding: "3px 4px 3px 10px",
                backgroundColor: user.email ? "#e8efff" : "#fdecec",
                color: user.email ? "#2563eb" : "#e5484d",
              }}
            >
              {user.full_name || user.user_code || "-"}
              <small className="fw-normal" style={{ opacity: 0.75, overflowWrap: "anywhere" }}>
                · {user.email || t("checklist_notify_chip_no_email")}
              </small>
              <button
                type="button"
                aria-label={`${t("checklist_notify_remove")} ${user.full_name || ""}`}
                className="border-0 rounded-circle bg-transparent p-0"
                style={{ width: "20px", height: "20px", color: "inherit", fontSize: "12px", lineHeight: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.remove(user);
                }}
              >
                ✕
              </button>
            </span>
          ))}
          <input
            ref={this.inputRef}
            type="text"
            role="combobox"
            aria-labelledby="notify-recipient-label"
            aria-autocomplete="list"
            aria-expanded={open}
            aria-controls="notify-user-list"
            aria-activedescendant={open && hits[active] ? `notify-user-${hits[active].uid}` : undefined}
            autoComplete="off"
            className="border-0 bg-transparent flex-grow-1 text-14"
            style={{ minWidth: "220px", padding: "4px 6px", outline: "none" }}
            placeholder={t("checklist_notify_search_placeholder")}
            value={search}
            onChange={(e) => this.openList(e.target.value)}
            onFocus={() => {
              clearTimeout(this.blurTimer);
              this.openList();
            }}
            // หน่วงปิดเล็กน้อย ให้การคลิกเลือกในรายการ (ที่โฟกัสกลับมาที่ช่องนี้) ไม่ทำให้รายการกะพริบ
            onBlur={() => {
              this.blurTimer = setTimeout(this.closeList, 100);
            }}
            onKeyDown={this.handleKeyDown}
          />
          {open && (
            <ul
              ref={this.listRef}
              id="notify-user-list"
              role="listbox"
              aria-label={t("checklist_notify_user_list")}
              className="list-unstyled m-0 bg-white rounded-3 shadow position-absolute"
              style={{ left: "-1px", right: "-1px", top: "calc(100% + 4px)", padding: "4px", border: "1px solid #c5cedb", maxHeight: "260px", overflowY: "auto", zIndex: 10 }}
              // mousedown + preventDefault = เลือกได้โดยช่องค้นหาไม่เสียโฟกัส
              onMouseDown={(e) => e.preventDefault()}
            >
              {hits.map((user, index) => (
                <li
                  key={user.uid}
                  id={`notify-user-${user.uid}`}
                  role="option"
                  aria-selected={index === active}
                  aria-disabled={!user.email}
                  className="d-flex align-items-center rounded-2"
                  style={{
                    gap: "10px",
                    padding: "7px 8px",
                    cursor: user.email ? "pointer" : "not-allowed",
                    opacity: user.email ? 1 : 0.5,
                    backgroundColor: index === active ? "#e8efff" : "transparent",
                  }}
                  onMouseDown={() => this.pick(user)}
                  onMouseMove={() => user.email && active !== index && this.setState({ active_uid: user.uid })}
                >
                  <span
                    aria-hidden="true"
                    className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-13 flex-shrink-0"
                    style={{ width: "32px", height: "32px", backgroundColor: "#e8efff", color: "#2563eb" }}
                  >
                    {String(user.full_name || "?").charAt(0)}
                  </span>
                  <span style={{ minWidth: 0 }}>
                    <span className="d-block fw-bold text-dark text-13">
                      {this.highlight(user.full_name || user.user_code)}
                      {user.position && <> · {this.highlight(user.position)}</>}
                    </span>
                    <span className="d-block text-12" style={{ color: user.email ? "#6b7688" : "#e5484d", overflowWrap: "anywhere" }}>
                      {user.email ? this.highlight(user.email) : t("checklist_notify_no_email")}
                    </span>
                  </span>
                </li>
              ))}
              {hits.length === 0 && (
                <li role="option" aria-selected={false} aria-disabled="true" className="text-secondary text-13" style={{ padding: "10px" }}>
                  {t("checklist_notify_user_not_found")} {search.trim() && `“${search.trim()}”`}
                </li>
              )}
            </ul>
          )}
        </div>
          {/* ทดสอบส่งเมล: ส่งอีเมลตัวอย่างตาม format จริงถึงผู้รับที่เลือกไว้ (ยังไม่ต้องบันทึกเทมเพลต) */}
          <button
            type="button"
            className="btn btn-outline-primary fw-bold text-13 rounded-3 flex-shrink-0 d-flex align-items-center"
            style={{ height: "40px", whiteSpace: "nowrap" }}
            disabled={!isOn}
            title={isOn ? undefined : t("checklist_notify_test_need_recipient")}
            onClick={this.props.onTest}
          >
            <span className="icon me-2">{"\uf1d8"}</span> {t("checklist_notify_test")}
          </button>
        </div>
        <small className="d-block text-secondary text-12 mt-2">{t("checklist_notify_hint")}</small>
      </div>
    );
  }
}

export default class ChecklistTemplates extends Component {
  constructor(props) {
    super(props);
    this.nameRef = React.createRef();
    this.headRef = React.createRef();
   this.state = {
      page: 1,
      page_size: 100000,
      uid: "",
      modal_create: false,
      modal_update: false,
      modal_view: false,
      filter_search: "",
      asset_group_id: "",

      template_name: "",
      category: "",
      description: "",
      // หมายเหตุรายบรรทัด: ติ๊กแล้วช่างใส่หมายเหตุได้ในทุกรายการตรวจสอบ
      is_remark_enabled: false,
      // ผู้รับอีเมลเมื่อผลตรวจไม่ผ่าน (object ผู้ใช้) - ว่าง = ไม่ส่งแจ้งเตือน
      notify_users: [],
      data_users: [],
      // ต้นไม้ Section / รายการ (ดู checklist-templates/checklistTree.js) + สถานะเทมเพลต
      checklist_tree: [],
      status: "active",
      editor_key: 0,
      // ชื่อเทมเพลตต้นทางเมื่อกด Duplicate (ว่าง = ไม่ใช่โหมดสำเนา)
      dup_from: "",
      view_data: null,
      data_categories: [],
      tabs: [{ value: "", label: t("all_templates") }],

      data: []
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  normalizeArrayData = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (payload && typeof payload === "object") return [payload];
    return [];
  }

  Get = async (page) => {
    const { filter_search, page_size, asset_group_id } = this.state;
    loading(true);
    let [resultTemplates, resultCategories, resultUsers] = await Promise.all([
      GET("admin/checklist-templates", {
        page: page,
        page_size: page_size,
        data_search: filter_search || "",
        asset_group_id: asset_group_id || "",
        uid: ""
      }),
      GET("warehouse/part-categories", { page_size: 10000, page: 0 }),
      // ผู้ใช้ของบริษัทสำหรับช่องค้นหาผู้รับแจ้งเตือน (รวมคนที่ยังไม่มีอีเมล - แสดงจางและเลือกไม่ได้)
      SHOW_FAIL_NOTIFY ? GET("admin/checklist-templates/notify-users", null) : null
    ]);

    const templateData = resultTemplates?.status ? this.normalizeArrayData(resultTemplates.data) : [];
    const categoryOptions = resultCategories?.status
      ? this.normalizeArrayData(resultCategories.data).map((item) => ({ value: item.uid, label: item.name }))
      : [];
    const fallbackCategories = templateData
      .map((item) => ({
        value: item.asset_group?.uid || "",
        label: item.asset_group?.name || t("general")
      }))
      .filter((item) => item.value && item.label);
    const dataCategories = categoryOptions.length > 0
      ? categoryOptions
      : fallbackCategories.filter((item, index, self) => self.findIndex((entry) => entry.value === item.value) === index);
    const tabs = [
      ...dataCategories
    ];

    if (resultTemplates?.status || resultCategories?.status) {
      this.setState({
        data: templateData,
        data_categories: dataCategories,
        tabs,
        page: page
      });
    }
    if (resultUsers?.status) {
      this.setState({ data_users: this.normalizeArrayData(resultUsers.data) });
    }
    loading(false);
  };

  handleSave = async () => {
    const { uid, template_name, category, description, checklist_tree, is_remark_enabled, notify_users, status } = this.state;
    if (!template_name) {
      alert("", "warning", t("warning"), t("please_enter_template_name"));
      return;
    }
    const problem = findProblem(checklist_tree);
    if (problem) {
      const reason =
        problem.type === "section_name"
          ? `${t("ct_err_section_name")} (Section ${problem.num})`
          : problem.type === "range"
            ? `${t("checklist_min_max_invalid")}: ${problem.node.description || "-"}`
            : `${t("ct_err_unit")}: ${problem.node.description || "-"}`;
      alert("", "warning", t("warning"), reason);
      return;
    }
    // ผู้รับที่อีเมลถูกลบออกจากข้อมูลผู้ใช้ภายหลัง - ระบบส่งไม่ถึง ให้เอาออกก่อน (backend ปฏิเสธเหมือนกัน)
    const recipientsWithoutEmail = notify_users.filter((user) => !user.email);
    if (SHOW_FAIL_NOTIFY && recipientsWithoutEmail.length) {
      alert("", "warning", t("warning"), `${t("checklist_notify_recipient_no_email")}: ${recipientsWithoutEmail.map((user) => user.full_name || user.user_code).join(", ")}`);
      return;
    }
    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      // sections + items ส่งคู่กันเสมอ = โครงสร้างทั้งชุด (เทมเพลตเดิมที่ไม่มี Section ได้ sections: [])
      const { sections, items } = toPayload(checklist_tree);
      const payload = {
        company_id: company?.id || "",
        asset_group_id: category,
        name: template_name,
        description: description,
        status,
        is_remark_enabled: !!is_remark_enabled,
        // ซ่อนอยู่ = ไม่ส่งฟิลด์นี้ backend จึงไม่แตะผู้รับชุดเดิม
        ...(SHOW_FAIL_NOTIFY ? { notify_user_ids: notify_users.map((user) => user.uid) } : {}),
        sections,
        // POST/PUT ตัดค่า null ทิ้งก่อนส่ง (removeEmptyString) แต่ backend ถือ "ไม่ส่ง" = ไม่แก้ค่าเดิม
        // min/max ที่ล้างเป็น "ไม่กำหนด" จึงต้องส่ง null จริง - NaN ผ่านตัวกรองและ JSON.stringify แปลงเป็น null
        items: items.map((item) => ({ ...item, min: item.min === null ? NaN : item.min, max: item.max === null ? NaN : item.max })),
      };

      let result = !uid
        ? await POST("admin/checklist-templates", payload)
        : await PUT("admin/checklist-templates/" + uid, payload);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  // ปุ่ม "ทดสอบส่งเมล": ส่งอีเมลตัวอย่างรูปแบบ "ผลตรวจไม่ผ่าน" ถึงผู้รับที่เลือกอยู่บนฟอร์ม
  // ใช้ค่าบนฟอร์มตอนนี้ (ชื่อ/คำอธิบาย/รายการตรวจ) จึงทดสอบได้โดยไม่ต้องบันทึกเทมเพลตก่อน
  handleTestNotify = async () => {
    const { uid, template_name, description, checklist_tree, notify_users } = this.state;
    const recipients = notify_users.filter((user) => user.email);
    if (!recipients.length) {
      alert("", "warning", t("warning"), t("checklist_notify_test_need_recipient"));
      return;
    }
    const emails = recipients.map((user) => user.email).join(", ");
    // ยืนยันก่อน เพราะอีเมลออกไปถึงผู้รับจริง
    if (!(await alert("", "info", t("checklist_notify_test"), `${t("checklist_notify_test_confirm")} ${emails}`, t("confirm"), t("cancel")))) {
      return;
    }
    loading(true);
    const result = await POST("admin/checklist-templates/notify-test", {
      notify_user_ids: recipients.map((user) => user.uid),
      // เทมเพลตที่กำลังแก้ไข (ฟอร์มสร้างใหม่ยังไม่มี uid) - backend ใช้ผูก audit log ของการทดสอบ
      uid: uid || "",
      name: template_name || "",
      description: description || "",
      items: toPayload(checklist_tree).items.map((item) => ({
        description: item.description,
        input_type: item.input_type,
        unit: item.unit,
        min: item.min,
        max: item.max
      }))
    });
    loading(false);
    if (result?.status === true) {
      // สรุปผลรายอีเมล: สำเร็จ/ไม่สำเร็จกี่เมล และเมลที่ไม่สำเร็จเรียงบรรทัดละ 1 เมล
      const successCount = result.data?.success_count ?? 0;
      const failed = Array.isArray(result.data?.failed) ? result.data.failed : [];
      const unit = t("checklist_notify_test_unit");
      const summaryHtml = [
        `<div>${t("checklist_notify_test_success")} ${formatNumber(successCount)} ${unit}</div>`,
        `<div>${t("checklist_notify_test_failed")} ${formatNumber(failed.length)} ${unit}</div>`,
        failed.length
          ? `<div style="margin-top:12px;font-weight:600">${t("checklist_notify_test_failed_list")}</div>` +
            failed.map((item) => `<div style="color:#e5484d;overflow-wrap:anywhere">${escapeHtml(item.email)}</div>`).join("")
          : "",
      ].join("");
      alert("", failed.length ? "warning" : "success", t("checklist_notify_test_result"), "", undefined, undefined, { html: summaryHtml });
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
  };

  handleDelete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/checklist-templates/" + id, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  openCreateModal = () => {
    this.setState((state) => ({
      modal_create: true, modal_update: false, modal_view: false,
      uid: "", template_name: "", category: "", description: "", dup_from: "",
      is_remark_enabled: true,
      status: "active",
      notify_users: [],
      checklist_tree: [],
      editor_key: state.editor_key + 1,
    }));
  }

  openEditModal = (item) => {
    this.setState((state) => ({
      modal_create: false, modal_update: true, modal_view: false,
      uid: item.uid, dup_from: "",
      template_name: item.name, category: item.asset_group?.uid || "", description: item.description,
      is_remark_enabled: !!item.is_remark_enabled,
      status: getTemplateStatus(item),
      notify_users: Array.isArray(item.notify_users) ? item.notify_users : [],
      checklist_tree: buildTree(item.sections, item.items),
      editor_key: state.editor_key + 1,
    }));
  }

  // Duplicate: คัดลอกฟอร์มที่เปิดอยู่เป็นเทมเพลตใหม่ (ไม่มี uid -> Save ไปทาง POST) ต้นทางไม่ถูกแตะ
  // editor_key เปลี่ยน = ต้นไม้ remount จึงออกจากโหมดย้ายตำแหน่งให้เอง
  handleDuplicate = () => {
    const { template_name, checklist_tree } = this.state;
    const src = (template_name || "").trim() || t("ct_dup_no_name");
    const suffix = ` ${t("ct_dup_suffix")}`;
    this.setState(
      (state) => ({
        modal_create: true, modal_update: false,
        uid: "",
        dup_from: src,
        template_name: src.slice(0, Math.max(0, 200 - suffix.length)) + suffix,
        status: "draft",
        checklist_tree: cloneTree(checklist_tree),
        notify_users: state.notify_users.map((user) => ({ ...user })),
        editor_key: state.editor_key + 1,
      }),
      () => {
        this.headRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = this.nameRef.current;
        if (input) {
          input.focus({ preventScroll: true });
          input.select();
        }
      }
    );
  };

  // Duplicate จากหน้าดู: สร้างสำเนาจาก view_data เปิดฟอร์มสร้างใหม่ (Draft) ต้นทางไม่ถูกแตะ
  handleDuplicateFromView = () => {
    const { view_data } = this.state;
    if (!view_data) return;
    const src = (view_data.name || "").trim() || t("ct_dup_no_name");
    const suffix = ` ${t("ct_dup_suffix")}`;
    this.setState(
      (state) => ({
        modal_view: false, modal_create: true, modal_update: false,
        uid: "", dup_from: src,
        template_name: src.slice(0, Math.max(0, 200 - suffix.length)) + suffix,
        category: view_data.asset_group?.uid || "",
        description: view_data.description || "",
        is_remark_enabled: !!view_data.is_remark_enabled,
        status: "draft",
        notify_users: Array.isArray(view_data.notify_users) ? view_data.notify_users.map((user) => ({ ...user })) : [],
        checklist_tree: cloneTree(buildTree(view_data.sections, view_data.items)),
        editor_key: state.editor_key + 1,
      }),
      () => {
        const input = this.nameRef.current;
        if (input) {
          input.focus({ preventScroll: true });
          input.select();
        }
      }
    );
  };

  openViewModal = (item) => {
    this.setState({
      modal_view: true,
      modal_create: false,
      modal_update: false,
      view_data: item
    });
  }

  getCategoryLabel = (item) => {
    const categoryId = item?.asset_group?.uid || "";
    return this.state.data_categories.find((category) => category.value === categoryId)?.label
      || item?.asset_group?.name
      || t("general");
  }

  render() {
   const {
      modal_create, modal_update, modal_view, filter_search, asset_group_id, tabs, data,
      template_name, category, description, checklist_tree, view_data, data_categories,
      is_remark_enabled, notify_users, data_users, status, editor_key, dup_from
    } = this.state;
    const filteredData = data;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("checklist_templates")}</h3>
                        <div className="text-secondary text-14">{t("checklist_desc")}</div>
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-primary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #0d6efd !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("total_templates")}</div>
                                    <h2 className="fw-bold mb-0 text-dark">{formatNumber(filteredData.length)}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf46c"}</div>
                            </div>
                        </div>
                    </div>
                    {/* KPI อื่นๆ ใช้โครงสร้างเดียวกัน */}
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-success rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #198754 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("active")}</div>
                                    <h2 className="fw-bold mb-0 text-success">{filteredData.filter((e) => getTemplateStatus(e) === "active")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-secondary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #ffc107 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("inactive")}</div>
                                    <h2 className="fw-bold mb-0 text-warning">{filteredData.filter((e) => getTemplateStatus(e) === "inactive")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf06a"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-secondary rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("draft")}</div>
                                    <h2 className="fw-bold mb-0 text-secondary">{filteredData.filter((e) => getTemplateStatus(e) === "draft")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary d-flex align-items-center justify-content-center text-20 icon">{"\uf044"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            <div className="position-relative">
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-350"
                                    style={{ height: "38px" }}
                                    placeholder={t("search")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <Select
                                className="form-control wpx-280"
                                options={tabs}
                                value={asset_group_id}
                                onChange={(e) => this.setState({ asset_group_id: e || "" })}
                                placeholder={t("all_templates")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", asset_group_id: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("checklist-templates.create") ? (
                        <button className="btn btn-primary fw-bold px-3 py-2 rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreateModal}>
                            <span className="me-2">+</span> {t("new_template")}
                        </button>
                        ) : null}
                    </div>
                </div>

                <div className="row g-3">
                    {filteredData.map((item, idx) => (
                        <div key={idx} className="col-lg-4 col-md-4">
                            <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                                <div className="pointer" onClick={() => this.openViewModal(item)}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <span
                                            className={`badge rounded-2 px-2 py-1 text-10 fw-bold bg-${item.asset_group?.uid ? "primary" : "secondary"}-light text-${
                                                item.asset_group?.uid ? "primary" : "secondary"
                                            }`}
                                        >
                                            {this.getCategoryLabel(item)}
                                        </span>
                                        <StatusPill status={getTemplateStatus(item)} />
                                    </div>

                                    <h5 className="fw-bold text-dark mb-2 text-truncate">{item.name}</h5>
                                    <div
                                        className="text-secondary text-12 mb-2"
                                        style={{ height: "36px", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
                                    >
                                        {item.description}
                                    </div>

                                    <div className="d-flex justify-content-between text-secondary text-12 mb-3">
                                        <div className="d-flex align-items-center fw-bold text-primary">
                                            <span className="icon me-2">{"\uf0ca"}</span> {formatNumber(item.items?.length || 0)} {t("items")}{item.sections?.length > 0 && ` · ${formatNumber(item.sections.length)} Section`}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <span className="icon me-2">{"\uf012"}</span> {t("used")} {formatNumber(item.usage_count || 0)} {t("times")}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="text-secondary text-10">
                                        {t("last_used")}: {item.updated_at ? format_date(item.updated_at.split("T")[0], "dd/mm/yyyy", "th") : "-"}
                                    </div>
                                    {/* ปุ่มจัดการชุดเดียวกับตารางทุกเมนู (ActionIconButton หยุด click ไม่ให้ทะลุไปเปิด modal ดูเอง) */}
                                    <div className="d-flex align-items-center gap-2">
                                        <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.openViewModal(item)} />
                                        {can("checklist-templates.update") ? (
                                        <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.openEditModal(item)} />
                                        ) : null}
                                        {can("checklist-templates.delete") ? (
                                        <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                {/* <div className="d-flex justify-content-between align-items-center mt-4">
                  <div className="text-secondary text-12">
                    {t("showing")} 1-{filteredData.length} {t("of")} {formatNumber(count)} {t("items")}
                  </div>
                  <Pagination
                    count={Math.ceil(count / this.state.page_size) || 1}
                    page={this.state.page}
                    onChange={(_, p) => this.Get(p)}
                    showFirstButton={false} showLastButton={false}
                  />
                </div> */}
            </div>

            {/* MODAL: VIEW */}
            <Modal size="md" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="border-bottom px-4 py-3 bg-white" closeButton>
                    <div className="w-100 pe-4">
                        <span className={`badge bg-primary-light text-primary rounded-pill px-3 py-1 mb-2 me-2 fw-bold text-12`}>{this.getCategoryLabel(view_data)}</span>
                        {view_data && <StatusPill status={getTemplateStatus(view_data)} />}
                        <h4 className="fw-bold mb-1 text-dark">{view_data?.name || t("template_title")}</h4>
                        <div className="text-secondary text-14">{view_data?.description}</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                    {/* แจ้งเตือนเมื่อผลไม่ผ่าน: มีผู้รับ = ส่ง / ไม่มี = ไม่ส่ง */}
                    {SHOW_FAIL_NOTIFY && (
                    <div className="bg-light rounded-3 p-3 mb-3">
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <span className="fw-bold text-dark text-13">{t("checklist_notify_title")}</span>
                            <span className={`text-12 fw-bold flex-shrink-0 ${view_data?.notify_users?.length ? "text-primary" : "text-secondary"}`}>
                                {view_data?.notify_users?.length
                                    ? `${t("checklist_notify_status_on_prefix")} ${formatNumber(view_data.notify_users.length)} ${t("checklist_notify_status_on_suffix")}`
                                    : t("checklist_notify_status_off")}
                            </span>
                        </div>
                        {view_data?.notify_users?.length > 0 && (
                            <div className="text-secondary text-12 mt-1" style={{ overflowWrap: "anywhere" }}>
                                {view_data.notify_users.map((user) => `${user.full_name || user.user_code || "-"} (${user.email || t("checklist_notify_chip_no_email")})`).join(", ")}
                            </div>
                        )}
                    </div>
                    )}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold text-dark d-flex align-items-center m-0">
                            <span className="icon text-primary me-2">{"\uf0ca"}</span> {t("checklist_items")}
                            {SHOW_REMARK_OPTION && view_data?.is_remark_enabled && (
                                <span className="badge bg-primary-light text-primary fw-bold px-2 py-1 text-11 ms-2">{t("checklist_remark_label")}</span>
                            )}
                        </h6>
                        <span className="text-secondary fw-bold text-14">
                            {formatNumber(view_data?.items?.length || 0)} {t("items")}
                        </span>
                    </div>
                    <div className="d-flex flex-column gap-2">
                        {view_data && renderViewNodes(buildTree(view_data.sections, view_data.items))}
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
                    {can("checklist-templates.create") ? (
                    <button className="btn btn-white border px-3 py-2 text-dark rounded-3 fw-medium" title={t("ct_dup_title")} onClick={this.handleDuplicateFromView}>
                        {t("ct_dup_btn")}
                    </button>
                    ) : null}
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_view: false })}>
                            {t("close")}
                        </button>
                        {can("checklist-templates.update") ? (
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm" onClick={() => this.openEditModal(view_data)}>
                            <span className="icon me-2">{"\uf044"}</span> {t("edit")}
                        </button>
                        ) : null}
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL: CREATE & EDIT */}
            <Modal
                size="xl"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header ref={this.headRef} className="border-0 px-4 py-3" style={{ backgroundColor: "#2563eb" }}>
                    <div className="text-white">
                        <h4 className="fw-bold mb-1 text-white">{t("create_new_template")}<span className="ct-stbadge">{statusLabel(status)}</span></h4>
                        <div className="text-white-50 text-14" style={{ color: "#bfdbfe" }}>
                            {dup_from ? `${t("ct_dup_from")} “${dup_from}”` : t("create_template_desc")}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", borderRadius: "8px", padding: "0.6rem" }}
                        onClick={() => this.setState({ modal_create: false, modal_update: false })}
                    ></button>
                </Modal.Header>

                <Modal.Body className="p-4 bg-white">
                    {dup_from && (
                        <div
                            role="status"
                            className="mb-3 px-3 py-2 text-13"
                            style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderLeft: "4px solid #2563eb", borderRadius: 8, color: "#1e3a8a" }}
                        >
                            {t("ct_dup_note_prefix")} “{dup_from}” {t("ct_dup_note_suffix")}
                        </div>
                    )}
                    <div className="row g-3 mb-4 pb-4">
                        <div className="col-md-6 col-lg-4">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("template_name_label")} <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                ref={this.nameRef}
                                maxLength={200}
                                className="form-control py-2 text-dark"
                                placeholder={t("template_name_placeholder")}
                                value={template_name}
                                onChange={(e) => this.setState({ template_name: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("machine_asset_group")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={data_categories}
                                value={category}
                                onChange={(e) => this.setState({ category: e })}
                                placeholder={t("select_machine_asset_group_placeholder")}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <StatusPicker value={status} onChange={(next) => this.setState({ status: next })} />
                        </div>
                        <div className="col-12 mt-3">
                            <label className="form-label text-14 fw-bold text-dark">{t("description")}</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder={t("checklist_description_placeholder")}
                                value={description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                            ></textarea>
                        </div>
                    </div>

                    {SHOW_FAIL_NOTIFY && (
                    <NotifyRecipientPicker
                        users={data_users}
                        value={notify_users}
                        onChange={(users) => this.setState({ notify_users: users })}
                        onTest={this.handleTestNotify}
                    />
                    )}

                    <div>
                        <ChecklistTreeEditor
                            key={editor_key}
                            tree={checklist_tree}
                            onChange={(next) => this.setState({ checklist_tree: next })}
                            headerExtra={
                                /* Remark: ติ๊กแล้วช่างใส่หมายเหตุได้ในทุกรายการตรวจสอบ (มีผลทั้งเทมเพลต ไม่ใช่รายข้อ) */
                                SHOW_REMARK_OPTION && (
                                <div className="d-flex align-items-center">
                                    <label
                                        htmlFor="template-remark"
                                        className={`d-flex align-items-center gap-2 mb-0 px-1 text-13 ${is_remark_enabled ? "fw-bold text-dark" : "text-secondary"}`}
                                        style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="template-remark"
                                            className="form-check-input m-0"
                                            style={{ width: 16, height: 16, cursor: "pointer" }}
                                            checked={!!is_remark_enabled}
                                            onChange={(e) => this.setState({ is_remark_enabled: e.target.checked })}
                                        />
                                        {t("checklist_remark_label")}
                                    </label>
                                    <InfoTooltip width="230px">{t("checklist_remark_tooltip")}</InfoTooltip>
                                </div>
                                )
                            }
                        />

                        <div className="alert d-flex align-items-start gap-3 p-3 rounded-3 mb-0" style={{ backgroundColor: "#eff6ff", border: "1px solid #bfdbfe" }}>
                            <span style={{ fontSize: "1.2rem", lineHeight: 1 }}>💡</span>
                            <div style={{ color: "#1e3a8a", fontSize: "14px" }}>
                                <div>
                                    <strong>{t("note")}:</strong> {t("checklist_measurement_note_prefix")} <strong>{t("measurement_type")}</strong> {t("checklist_measurement_note_middle")} <strong>Min/Max</strong> {t("checklist_measurement_note_suffix")}
                                </div>
                                <div>
                                    {t("checklist_required_note_prefix")} <strong>{t("required_label")}</strong> {t("checklist_required_note_suffix")}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        {modal_update && (
                            <button
                                type="button"
                                className="btn btn-white border px-3 py-2 text-dark rounded-3 fw-medium"
                                title={t("ct_dup_title")}
                                onClick={this.handleDuplicate}
                            >
                                {t("ct_dup_btn")}
                            </button>
                        )}
                        {(() => {
                            const sum = summarize(checklist_tree);
                            return (
                                <span className="text-secondary text-13">
                                    {formatNumber(sum.sections)} Section · {formatNumber(sum.items)} {t("items")} · {t("checklist_required_summary")} {formatNumber(sum.required)} · {t("checklist_optional_summary")} {formatNumber(sum.optional)}
                                </span>
                            );
                        })()}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-medium" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            {t("cancel")}
                        </button>
                        <button
                            onClick={this.handleSave}
                            className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                        >
                            <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
